import jsonCastellano from './castellano.json';
import jsonInglesGB from './ingles-gb.json';

export const LanguagesJson:any = {
    ...jsonCastellano,
    ...jsonInglesGB
}